import GA from '~/services/GA/GA';
import logging from '~/stores/providers/logging';
import { isElectron } from '~/utils/runEnvironmentUtil';

const electron = () => {
  return isElectron() ? window.require('electron') : null;
};

const send = (type, data) => {
  if (!isElectron()) return;
  const id = data?.domainInfo?.id;
  if (id) {
    data.domainInfo.id = +id;
  }
  electron().ipcRenderer.send(type, data);
};

const off = (type, callback) => {
  if (!isElectron()) return;
  electron().ipcRenderer.removeListener(type, callback);
};

const on = (type, callback) => {
  if (!isElectron()) return;
  off(type, callback);
  electron().ipcRenderer.on(type, callback);
};

const isCurrentWebContents = () => {
  const webContents = electron().remote?.webContents.getFocusedWebContents();
  const url = webContents && webContents.getURL();
  return window.location.href === url;
};

const hasFocus = () => {
  if (!isElectron()) {
    return document.hasFocus();
  }
  try {
    return document.hasFocus() || isCurrentWebContents();
  } catch (e) {
    return document.hasFocus();
  }
};

const clearCache = () => {
  if (!isElectron()) return;
  try {
    electron().remote?.session.defaultSession.clearCache();
  } catch (error) {
    logging.log('clear Cache Error');
    GA.writeClearCacheError();
  }
};

const electronService = {
  send,
  on,
  off,
  clearCache,
  hasFocus,
};
export default electronService;
